import { createFileRoute } from '@tanstack/react-router'
import { CalendarClock } from 'lucide-react'
import { RequirePermission } from '@/components/ui/require-permission'
import { Main } from '@/components/layout/main'
import { AppHeader } from '@/components/layout/page'
import { BillingCycleList } from '@/features/billing-cycles'

export const Route = createFileRoute('/_authenticated/billing/billing-cycles')({
  component: () => (
    <RequirePermission permission='billing_cycles.read'>
      <BillingCyclesPage />
    </RequirePermission>
  ),
})

function BillingCyclesPage() {
  return (
    <>
      <AppHeader title='Billing Cycle' icon={CalendarClock} />

      <Main>
        <BillingCycleList />
      </Main>
    </>
  )
}
